import { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import HomeHero from "../components/home/HomeHero";
import HomeProblem from "../components/home/HomeProblem";
import HomeSteps from "../components/home/HomeSteps";
import HomeWall from "../components/home/HomeWall";
import HomeContrast from "../components/home/HomeContrast";
import HomeFinalCTA from "../components/home/HomeFinalCTA";
import HomeFAQ from "../components/home/HomeFAQ";
import Footer from "../components/Footer";
import CookieBanner from "../components/CookieBanner";
import { ScrollReveal } from "../hooks/useScrollReveal";

const LandingPage = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!window.location.hash) return;
    const id = window.location.hash.slice(1);
    let tries = 0;
    const timer = setInterval(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        clearInterval(timer);
      } else if (++tries > 20) {
        clearInterval(timer);
      }
    }, 120);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="min-h-screen bg-white overflow-x-hidden" data-testid="landing-page">
      <Navbar isScrolled={isScrolled} ctaAfterHero />
      <main>
        <HomeHero />
        <ScrollReveal>
          <HomeProblem />
        </ScrollReveal>
        <ScrollReveal>
          <HomeSteps />
        </ScrollReveal>
        <ScrollReveal>
          <HomeWall />
        </ScrollReveal>
        <ScrollReveal>
          <HomeContrast />
        </ScrollReveal>
        <ScrollReveal>
          <HomeFinalCTA />
        </ScrollReveal>
        <ScrollReveal>
          <HomeFAQ />
        </ScrollReveal>
      </main>
      <Footer withDemoForm={false} />
      <CookieBanner />
    </div>
  );
};

export default LandingPage;
